import { createTheme } from '@mui/material/styles';

/**
 * Shared by the admin and vendor consoles so the two read as one product.
 * The storefront uses plain CSS custom properties tuned to the same palette.
 */
export const theme = createTheme({
  palette: {
    // Brand book v1.0. Blue is the guide colour and so becomes MUI's
    // "primary" (links, selected states, tabs); green is the action colour
    // reserved for confirming buttons and success states. They are never
    // placed against each other — the book is explicit that they meet only
    // through white.
    primary: { main: '#0c93da', contrastText: '#ffffff' },
    secondary: { main: '#0aa680', contrastText: '#ffffff' },
    background: { default: '#f4f6f5' },
    text: { primary: '#14313a', secondary: '#5f7480' },
    success: { main: '#0aa680' },
    warning: { main: '#b26a00' },
    error: { main: '#c22f2f' },
    divider: '#dfe5e4',
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: '"Poppins", ui-sans-serif, system-ui, sans-serif',
    h1: { fontFamily: '"Fira Sans", sans-serif', fontSize: '1.75rem', fontWeight: 700 },
    h2: { fontFamily: '"Fira Sans", sans-serif', fontSize: '1.375rem', fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiPaper: { defaultProps: { elevation: 0 }, styleOverrides: { root: { border: '1px solid #dfe5e4' } } },
  },
});
